
























import Vue from 'vue'
export default Vue.extend({
  props: {
    text: {
      required: false,
      default: true,
      type: Boolean,
    },
    prev: {
      required: false,
      default: true,
      type: Boolean,
    },
    next: {
      required: false,
      default: true,
      type: Boolean,
    },
    loading: Boolean,
  },
})
